import { AxiosResponse } from "axios";

import API from "../api";

import { Project } from "../models/project";
import BaseService from "./_base.service";

const ROUTE_NAME = "projects";

interface ProjectListResponse {
  data: Project[];
  total: number;
}

const ProjectService = {
  ...BaseService<Project>({ endpoint: ROUTE_NAME }),
  async get(options?: any): Promise<AxiosResponse<any>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async all(options?: any): Promise<AxiosResponse<ProjectListResponse>> {
    return await API.get(`/${ROUTE_NAME}/all`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<Project[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async list(options?: any): Promise<AxiosResponse<any>> {
    return await API.get(`/${ROUTE_NAME}/list/all`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<any>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async getAllShip(): Promise<AxiosResponse<any>> {
    return await API.get(`/shipments/get/projects/all/:all`);
  },
  async getAllCombobox(): Promise<AxiosResponse<any>> {
    return await API.get(`/${ROUTE_NAME}/combobox`);
  },
  async create(project: any): Promise<AxiosResponse<Project>> {
    return await API.post(`/${ROUTE_NAME}`, project);
  },
  async update(data: any): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${data?.id}`, data);
  },
  async delete(id: number): Promise<AxiosResponse<any>> {
    return await API.delete(`/${ROUTE_NAME}/${id}`);
  },
  async uploadCSV(userId: number, projectId: number, file: FormData): Promise<AxiosResponse<any>> {
    return await API.post(`/${ROUTE_NAME}/upload/csv/${userId}/${projectId}`, file);
  },
};

export default ProjectService;
